import React from 'react';
import styles from './Section.module.css';

const HGSwap = () => {
  return (
    <div className={styles.contentSection}>
      <div className={styles.sectionTitle}>Swap Policy</div>
      <div className={styles.sectionContent}>
        <p>Jackopot has a strict anti-money laundering policy. This is in accordance with our AML procedures outlined in our terms of service. If deposits & withdrawals are suspected of being attempts to Swap coins we reserve the right to hold withdrawals until completion of one of the following procedures:</p>
        <ol>
          <li>Withdrawal is sent after full completion of account verification & KYC</li>
          <li>Withdrawal refunded & 1x gameplay is reached.</li>
        </ol>
        <p>Swap will always try to ensure every matter is resolved & the above can be modified to suit specific situations.</p>
      </div>
    </div>
  );
};

export default HGSwap;
